<div class="desktop">
  <div class="card mensaje">
    <div class="card-body">
      <div class="container">
        <div class="row">
          <div class="col-sm-1" style="width: 55px; margin-top: 5px;">
            <div class="linea"></div>
            <img class="iconoinformacionCard" style="margin-top: 8px;" src="./assets/img/Icons_SM.svg">
          </div>
          <div class="col">
            <div class="proceso">Para realizar el proceso:<br>Debes contar con la información de tu inquilino: País de
              nacimiento, número de documento, fecha de expedición, celular y correo electrónico.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modile">
  <div class="card mensaje">
    <div class="card-body">
      <div class="container">
        <div class="row">
          <div class="col-auto">
            <div class="linea"></div>
            <img class="iconoinformacionCard" src="./assets/img/Icons_SM.svg">
          </div>
          <div class="col">
            <div class="proceso">Para realizar el proceso: </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="detalleMobile">
              Debes contar con la información de tu inquilino: País de nacimiento, número de
              documento, fecha de expedición, celular y correo electrónico.
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>